import { Flex } from "emoreg";
import { color, spaces } from "emoreg/const";
import { forTabletUp } from "emoreg/utils/responsive";
import styled from "styled-components";

export const ColumnsContainer = styled(Flex)(
  { flexWrap: "wrap", minWidth: "80vw" },
  forTabletUp({ maxHeight: "100vh", overflowX: "auto", minWidth: "unset" })
);
ColumnsContainer.displayName = "ColumnsContainer";

export const BatchSelectorContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: ${spaces[24]};
`;
BatchSelectorContainer.displayName = "BatchSelectorContainer";

export const ClickableText = styled.p`
  color: ${color.grey.dark};
  &:hover {
    text-decoration: underline;
  }
  cursor: pointer;
`;
ClickableText.displayName = "ClickableText";
